import { log } from "../../shared/services/debug-logger";
import { atom } from "jotai";
import { atomWithStorage, RESET } from "jotai/utils";

export const bqF1GeneralInformationAtom = atomWithStorage<any>("bqF1GeneralInformation", {});
export const bqF2CertificationAtom = atomWithStorage<any>("bqF2Certification", {});
export const bqF3CrewManagementAtom = atomWithStorage<any>("bqF3CrewManagement", {});
export const bqF4SafetyManagementAtom = atomWithStorage<any>("bqF4SafetyManagement", {});
export const bqF5CargoArrangementsAtom = atomWithStorage<any>("bqF5CargoArrangements", {});
export const bqF6CargoGearAtom = atomWithStorage<any>("bqF6CargoGear", {});
export const bqF7ContainerAtom = atomWithStorage<any>("bqF7Container", {});
export const bqF8MooringAtom = atomWithStorage<any>("bqF8Mooring", {});
export const bqF9EngineRoomAtom = atomWithStorage<any>("bqF9EngineRoom", {});
export const bqF10MiscellaneousAtom = atomWithStorage<any>("bqF10Miscellaneous", {});

export const bqFormsExportAtom = atom((get) => ({
  bqF1GeneralInformation: get(bqF1GeneralInformationAtom),
  bqF2Certification: get(bqF2CertificationAtom),
  bqF3CrewManagement: get(bqF3CrewManagementAtom),
  bqF4SafetyManagement: get(bqF4SafetyManagementAtom),
  bqF5CargoArrangements: get(bqF5CargoArrangementsAtom),
  bqF6CargoGear: get(bqF6CargoGearAtom),
  bqF7Container: get(bqF7ContainerAtom),
  bqF8Mooring: get(bqF8MooringAtom),
  bqF9EngineRoom: get(bqF9EngineRoomAtom),
  bqF10Miscellaneous: get(bqF10MiscellaneousAtom),
}));

export const resetBalticFormStorageAtom = atom(null, (_get, set) => {
  log("STATE - resetBalticFormStorageAtom");
  set(bqF1GeneralInformationAtom, RESET);
  set(bqF2CertificationAtom, RESET);
  set(bqF3CrewManagementAtom, RESET);
  set(bqF4SafetyManagementAtom, RESET);
  set(bqF5CargoArrangementsAtom, RESET);
  set(bqF6CargoGearAtom, RESET);
  set(bqF7ContainerAtom, RESET);
  set(bqF8MooringAtom, RESET);
  set(bqF9EngineRoomAtom, RESET);
  set(bqF10MiscellaneousAtom, RESET);
});
